import { createSimpleRegionFunctions } from "./region-functions-simple";

// Belgian phone number format: +32 or 0
export const BERegionFunctions = createSimpleRegionFunctions({
	countryCode: "+32",
	phonePrefix: "0",
});
